import React from 'react';

const Courtesy = () => (
  <div className="courtesy-page">
    <img src="/images/saipem-full.png" alt='Saipem logo'/>
    <h3 className="">Something went wrong</h3>
    <p>Either the provided URL is invalid or the requested worksite/project are not available.</p>
  </div>
)

export default Courtesy;
